/**
 * Created by lid4jcu on 03/30/2017.
 */

module.exports = function (app) {
    "use strict";

    app.filter('removeUnderscore', function () {
        return function (raw) {
            return raw.split('_').join(' ') || '';
        };
    });

    app.directive('formCompleteWidget', function ($compile, $timeout) {

        return {

            priority: -1,
            //terminal: true,
            template: require('directives/common/formCompleteWidget.html'),
            restricted: "A",
            replace: true,
            require: "^form",
            link: function (scope, element, attribute, form) {

                scope.errorCount = 0;
                scope.nestedFormArray = [];

                function getErrors() {
                    scope.errorCount = 0;
                    var formErrors = [];
                    angular.forEach(
                        form.$error,
                        function (errorCategory) {
                            angular.extend(formErrors, errorCategory);

                            //scope.errorCount = scope.errorCount + errorCategory.length;

                            //for (var i = 0; i < errorCategory.length; i++) {
                            //angular.forEach(
                            //    errorCategory[i].$error,
                            //function (formErrors) {
                            //scope.errorCount = scope.errorCount + errorCategory[i].$error[errorKey].length;
                            //});
                            //}
                        });

                    scope.errorCount = scope.errorCount + formErrors.length;

                }


                $timeout(function () {
                    scope.$watch(function () { return form.$error },
                                           function (newValue, oldValue) {
                                               getErrors();
                                               //scope.errorCount = form.$error.required.length;
                                           }, true);

                    angular.forEach(form,
                        function (nestedForm) {
                        //Make sure we are looking at a form, and grab it.
                        if (nestedForm && nestedForm.$$parentForm) {
                            scope.nestedFormArray.push(nestedForm);
                        }
                    });

                }, 0);


                scope.goToValidation = function (form) {

                    var invalidInput = angular.element('[name=' + form.$name + '] .ng-invalid');

                    form && form.$setDirty;

                    invalidInput.focus();

                    //TODO: scroll hates me
                    $timeout(function () {
                        angular.element('html, body').animate({ scrollTop: invalidInput.offset().top - 80 }, 1000);
                    }, 100);

                };

            }
        };
    });
};
